export interface WikiBrandArticle {
  slug: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  metaKeywords: string;
  category: string;
  subcategory: string;
  excerpt: string;
  content: string;
  image: string;
  readTime: string;
  tags: string[];
  date: string;
  author: string;
  authorRole: string;
  faq: Array<{ question: string; answer: string }>;
}

const IMG_01 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/7e3bd338-1e37-4b2f-b09d-e8387526fb9e_compressed_fw-founder-01-2014-east-africa-fieldwork.webp';
const IMG_02 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/b930bc41-9124-4b29-adb4-64641adbcf3a_compressed_fw-founder-02-2015-antarctica-fieldwork.webp';
const IMG_03 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/83777e4b-1bed-49ca-9af8-854f899fd896_compressed_fw-founder-03-2017-botswana-early-team.webp';
const IMG_04 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/8ff0c9b3-0fe0-40c3-b2e5-3d4e84463eba_compressed_07-2024--.webp';
const IMG_05 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/0a2ab4ae-b4ba-4ff0-8337-86130914687a_compressed_fw-founder-05-2025-botswana-vumbura-plains.webp';
const IMG_06 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/ca0e7e3a-ef38-498e-a75e-ef4d5558c3fa_compressed_fw-founder-06-2026-botswana-safari.webp';
const IMG_07 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/1270d8b6-0a5b-417e-971e-15d360797a6c_compressed_fw-founder-07-2026-rwanda-gorilla-fieldwork.webp';
const IMG_08 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/47c97f4a-4cd8-4d3c-969f-bb77dd9eccc2_compressed_fw-founder-08-2026-rovos-rail-southern-africa.webp';

const BRAND_MEETINGS_DESKTOP = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/6a72a26a-2c06-451f-89b5-71bc29cc7af4_compressed_free-wilderness-brand-meetings-collage-desktop.webp';
const BRAND_MEETINGS_MOBILE = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/cc7a30fa-1138-4bb9-9618-a4174a0e66fd_compressed_free-wilderness-brand-meetings-collage-mobile.webp';

const WAA01 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/453bf3b4-6cb0-4bc2-9ac8-8dad0fca43d8_compressed_01-free-wilderness-lemala.webp';
const WAA02 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/98cc0e44-46f5-4418-8aac-94ec93d1f7ce_compressed_02-free-wilderness-singita.webp';
const WAA03 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/bf9d3a8f-334a-4a3d-9589-8d6390bce65a_compressed_03-free-wilderness-belmond.webp';
const WAA04 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/30251f7b-b4af-4e4a-97ef-d406ae9c9299_compressed_04-free-wilderness-one-nature.webp';
const WAA05 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/24e70989-40ac-45e8-b7d3-0e3cfa5e5d25_compressed_05-free-wilderness-angama.webp';
const WAA06 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/ae74946b-7106-4779-8755-4cf92fb23dbb_compressed_06-free-wilderness-machaba-safaris.webp';
const WAA07 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/0871445a-c279-4d60-9ab1-f1bc72f1effd_compressed_07-free-wilderness-jao-reserve.webp';
const WAA08 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/32a178c5-4036-414c-9473-fb7cc2c25512_compressed_08-free-wilderness-bushcamp-company.webp';
const WAA09 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/38e8c22e-ef86-48e1-b4f5-e0e065243898_compressed_09-free-wilderness-songa-africa.webp';
const WAA10 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/5d8b6390-586d-469e-8a9f-a41f9815c29b_compressed_10-free-wilderness-karibu-camps-lodges.webp';
const WAA11 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/529a582f-9c56-4124-bad6-188d5f979ba4_compressed_11-free-wilderness-acacia-collections.webp';
const WAA12 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/e44b9435-ccff-4bbb-bdbe-14798179afa1_compressed_12-free-wilderness-sisini-collections.webp';
const WAA13 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/27cb37d2-7a87-4396-b267-7a596bfa9999_compressed_13-free-wilderness-kantabile-afrika.webp';
const WAA14 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/dd2addd7-468e-4a49-b335-a88d6a7b2ba2_compressed_14-free-wilderness-okavango-hidden-gems.webp';
const WAA15 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/7e1bc4ec-66c6-4c20-a4f5-17045e84391f_compressed_15-free-wilderness-desert-delta-safaris.webp';

const SCOUT01 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/27813a18-1957-4573-aa29-e7e764bc69ac_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-001-0e6ffe24ac.webp';
const SCOUT02 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/9df4b98b-7368-4911-961f-4a9068e059cc_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-002-6b2f4cb2bb.webp';
const SCOUT03 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/f4d7fbe0-0cee-43e1-944e-c0c9a9b19b20_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-003-a9ccda7c0e.webp';
const SCOUT04 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/f3783b2f-72eb-46f9-b851-613c84d57de7_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-004-a30b55cc4a.webp';
const SCOUT05 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/60466da8-2b51-4acc-bb95-cc9807b5d98b_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-005-fb74d62d27.webp';
const SCOUT06 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/9615434d-0903-4460-9202-011faaad1d07_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-006-6aa15c0b8f.webp';
const SCOUT07 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/eb53a2c2-c8a6-4d4d-9fd3-b9d23488bbb4_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-007-2974396e93.webp';
const SCOUT08 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/49601c75-f1d5-4c6c-8a38-88c972290097_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-008-8c08689ed3.webp';
const SCOUT09 = 'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/bd2aa065-f94a-42b9-b13d-ed91ded67f5d_compressed_safari-10-founder-lizhiqiang-africa-luxury-scouting-img-009-ddf842b368.webp';

const brandMeetingsFaq = [
  {
    question: 'WAA是什么展会？',
    answer: 'WAA是We Are Africa的简称，是在南非开普敦举行的非洲高端旅行行业交流活动，连接非洲旅行品牌、专业买家和旅游媒体，重点关注高端、创意和有责任感的非洲旅行方式。',
  },
  {
    question: '自由旷野旅行是否参加了WAA 2026？',
    answer: '2026年5月，自由旷野旅行前往南非开普敦参加We Are Africa 2026，并与多家非洲野奢酒店和旅行品牌进行现场交流。',
  },
  {
    question: '自由旷野旅行在WAA 2026交流了哪些品牌？',
    answer: '现场交流品牌包括Singita、Lemala Camps & Lodges、Belmond、One Nature、Angama、Machaba Safaris、Jao Reserve、The Bushcamp Company、Songa Africa、Karibu Camps & Lodges、Acacia Collections、Sisini Collection、Kantabile Afrika、Okavango Hidden Gems、Desert & Delta Safaris等数十家常合作的野奢品牌。',
  },
  {
    question: '双方主要交流了什么？',
    answer: '交流内容包括非洲Safari线路设计、迁徙季营地选择、亲子与蜜月需求、私人车辆、向导与活动匹配、跨境及小飞机衔接、在地服务、可持续旅行和突发情况响应。',
  },
  {
    question: '现场合影是否代表已经签署正式合作协议？',
    answer: '不代表。现场合影能够证明双方进行过面对面交流并建立友好业务联系，但不单独等同于签约、独家代理或官方授权。具体合作产品、价格、房态和权益以后续书面确认及实际预订为准。',
  },
  {
    question: '这些交流对旅行者有什么实际帮助？',
    answer: '直接沟通有助于自由旷野旅行更快了解营地位置、季节变化、儿童政策、活动限制和接驳条件，从而为不同客人设计更合适的路线，并在行程发生变化时提高沟通效率。',
  },
];

/* ─────────────────────────────────────────────
   人物故事文章：创始人·实地笔记
   路由：/wiki/brand/founder-field-notes
   ───────────────────────────────────────────── */
const founderFieldNotesContent = `
<p class="text-base md:text-lg leading-[1.8] mb-6">一条旅行线路，究竟从哪里开始？</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">对自由旷野旅行来说，它往往不是从酒店清单、网络图片或一张地图开始，而是从一次真实抵达开始：走进草原，坐进Safari车辆，住进营地，经历不同季节的天气和路况，再把沿途看到的问题一项项带回行程设计中。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">自由旷野旅行（Free Wilderness Travel）由成都自由旷野国际旅行社有限公司运营，品牌与公司成立于2022年。品牌成立之前，创始人李志强已经在高端定制旅行行业积累了多年的目的地经验。2013年，是他的个人从业起点，而不是当前公司的成立时间。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_01}" alt="2014年李志强在东非进行目的地实地考察" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2014年，李志强前往埃塞俄比亚与坦桑尼亚进行目的地实地考察。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">从2013年出发，把目的地变成现场</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2013年进入高端定制旅行行业后，李志强开始长期接触目的地研究、线路策划与旅行服务。对当时的他来说，判断一条线路是否合理，不能只看目的地有多著名，更要看旅行者真正抵达后会经历什么。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">2014年，他前往埃塞俄比亚与坦桑尼亚。从城市衔接到东非草原，从长途交通到Safari节奏，这次抵达让非洲不再只是资料中的目的地，而成为可以被观察、比较和不断修正的真实现场。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">三年后的2017年，早期从业团队进入博茨瓦纳，开展目的地考察，不仅了解营地衔接、轻型飞机交通与Safari旅行场景，也开始从地理位置、住宿风格和实际体验等角度比较不同营地，为后续的行程设计与选店判断积累现场经验。这里没有统一复制的观光路线：水位、季节、动物活动和营地位置，都可能改变一段旅程的体验。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_03}" alt="2017年早期从业团队在博茨瓦纳进行目的地考察" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2017年，早期从业团队在博茨瓦纳了解营地、交通与Safari旅行场景。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">这些经历逐渐形成一种工作习惯：在向客户推荐之前，先尽可能理解目的地真实的运行方式。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">从非洲到极地，建立对自然旅行的判断</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2015年，李志强第一次抵达南极，亲身体验极地航行、登陆活动和不断变化的天气环境。2019年，他又前往格陵兰与冰岛，将目的地经验从南极延伸至北极圈。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_02}" alt="2015年李志强在南极进行实地体验" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2015年，李志强第一次抵达南极，体验极地环境与登陆活动。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">非洲草原和极地冰原看似完全不同，却都要求旅行者尊重自然的不确定性。野生动物不会按照行程表出现，登陆点可能受天气影响，营地体验也会随着季节变化。真正专业的规划，不是承诺所有事情必然发生，而是提前理解变量，设计更合理的节奏，并为可能发生的变化留下空间。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">这也成为自由旷野后来进行非洲Safari和南北极自然旅行规划时的重要原则。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">2022年，把个人积累转化为品牌方法</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2022年，自由旷野旅行品牌与成都自由旷野国际旅行社有限公司成立。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">品牌没有把2013年包装成公司成立年份，而是明确区分两段历史：2013年是创始人的个人从业起点；2022年是当前品牌与公司主体的成立时间。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">成立自由旷野旅行，是希望把此前积累的目的地理解，转化为一套更稳定的旅行服务方法。它不只关心"去哪些地方"，也关心每天的路程是否合理、营地之间怎样衔接、向导是否了解动物、住宿体验是否符合旅行者真正的偏好，以及国内协调如何让远距离旅行更安心。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">成立以后，继续回到非洲</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">品牌成立并不意味着实地探索告一段落。2023年，李志强再次前往坦桑尼亚，从Safari车辆、线路节奏到营地体验进行一线观察。2024年，团队与坦桑尼亚当地接待团队面对面交流，继续了解目的地运营、向导服务与现场协作。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_04}" alt="2024年李志强在坦桑尼亚与当地团队进行现场交流" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2024年，李志强在坦桑尼亚与当地团队交流目的地接待与现场协作。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">这些工作不一定会直接出现在一份行程单里，却会影响旅行的很多细节：某段车程是否过长、哪个区域更适合多住一晚、不同季节如何选择营地、当地团队遇到变化时怎样响应。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">在博茨瓦纳，看见Safari的另一种节奏</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2025年，团队再次深入博茨瓦纳，不只体验Safari活动，也以真实住客视角入住和走访多家野奢营地，从客房、餐饮、向导、活动节奏、转场效率与服务细节等维度进行比较，为旅行者筛选更匹配的住宿选择。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_05}" alt="2025年李志强在博茨瓦纳Vumbura Plains进行实地体验" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2025年，亲自入住奥卡万戈三角洲Wilderness多家营地，在水陆交错的环境中体验营地服务与Safari活动，观察季节变化带来的差异，并进一步判断不同营地更适合摄影、亲子、蜜月，还是偏爱私密感与深度Safari的旅行者。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">对高品质自然旅行而言，昂贵并不自动等于合适。营地所在区域、季节水位、活动方式、房间数量和整体氛围，都会影响最终体验。反复回到同一目的地，是为了在不同时间和现场条件下重新观察，而不是仅凭一次到访就给出永久不变的答案。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">2026年，李志强继续深入博茨瓦纳，持续核验不同区域、季节和价位的野奢营地真实入住体验。根据旅行者的兴趣、节奏与预算，匹配更合适的酒店和行程组合，让预算优先投入真正重视的体验；同时依托与当地多家酒店集团直签合作，提高房态、价格与服务衔接的匹配效率。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_06}" alt="2026年李志强再次在博茨瓦纳进行Safari实地考察" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2026年，李志强再次深入博茨瓦纳进行Safari实地考察。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">从草原走进卢旺达山地森林</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2026年5月，李志强前往卢旺达开展山地大猩猩旅行实地体验。与车辆Safari不同，山地大猩猩追踪需要在专业人员带领下进入森林，实际过程会受到地形、天气和大猩猩当天活动位置等因素影响。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_07}" alt="2026年李志强在卢旺达山地大猩猩实地考察中留影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2026年5月，李志强在卢旺达山地大猩猩实地考察现场留影。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">这次抵达补充了团队对东非山地森林旅行的现场理解：不仅要考虑追踪许可证和交通时间，也要理解徒步强度、森林条件、住宿位置与现场组织之间的关系。照片记录的是一次真实抵达，并不代表野生动物活动可以被预先保证。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">同年，李志强体验南部非洲铁路旅行产品。从草原营地到非洲之傲列车，团队继续补充对南部非洲交通、住宿和服务衔接的理解。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${IMG_08}" alt="2026年李志强体验南部非洲非洲之傲列车" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">2026年，李志强体验南部非洲铁路旅行产品与服务衔接。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">实地经历最终要回到旅行者</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">对于客户来说，目的地考察的价值并不在于展示去过多少国家，而在于这些经历是否真正进入服务：</p>

<ul class="list-disc pl-6 mb-6 space-y-2 text-base md:text-lg leading-[1.8] text-[#1a2e10]">
  <li>设计行程时，减少不必要的往返和过度赶路；</li>
  <li>选择营地时，不只看品牌名称，也结合区域、季节和活动方式；</li>
  <li>安排Safari或森林追踪时，理解当地向导和现场组织的重要性；</li>
  <li>面对动物活动、天气和交通变化时，保留合理预期与应对空间；</li>
  <li>在长距离旅行中，做好国内沟通与海外落地服务之间的衔接。</li>
</ul>

<p class="text-base md:text-lg leading-[1.8] mb-6">从2013年的个人从业起点，到2022年自由旷野旅行成立，再到此后持续深入坦桑尼亚、博茨瓦纳、卢旺达和南部非洲，变化的是时间与目的地，不变的是同一个判断标准：没有一种真正值得信任的自然旅行经验，可以完全绕过现场。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">自由旷野旅行不会把每一次抵达包装成奖项，也不会把不可预测的自然写成保证。团队更愿意把路线重新走一遍，把营地真正住一次，把复杂的衔接亲身经历过，再把这些判断放进下一位旅行者的行程里。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">这条实地路径仍在继续。</p>

<div class="bg-[#e8f0e0] rounded-xl p-6 md:p-8 my-10">
  <p class="text-[#1a4a1a] font-bold text-lg mb-2">关于自由旷野旅行</p>
  <p class="text-stone-700 text-sm md:text-base leading-relaxed">自由旷野旅行（Free Wilderness Travel）由成都自由旷野国际旅行社有限公司运营，品牌与公司成立于2022年，专注非洲Safari、南北极及自然类定制旅行。创始人李志强自2013年进入高端定制旅行行业，并与团队持续进行目的地实地体验、线路研究与在地资源交流。</p>
  <p class="text-stone-700 text-sm md:text-base leading-relaxed mt-2">官方网站：<a href="https://freewds.com/" class="text-[#1a4a1a] hover:underline" target="_blank" rel="noopener noreferrer">https://freewds.com/</a></p>
</div>
`;

/* ─────────────────────────────────────────────
   品牌合作文章：合作交流合影
   路由：/wiki/brand/brand-cooperation-exchange
   ───────────────────────────────────────────── */
const brandMeetingsContent = `
<p class="text-base md:text-lg leading-[1.8] mb-6">2026年5月，自由旷野旅行前往南非开普敦，参加非洲高端旅行行业展会 We Are Africa 2026（简称 WAA）。WAA 汇集非洲高端旅行品牌、国际买家与旅游媒体，是了解新营地、新体验和在地服务变化的重要行业交流平台。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">展会期间，自由旷野旅行与 Singita、Lemala、Belmond、One Nature、Angama 等数十家常合作的非洲野奢酒店及旅行品牌代表进行了面对面交流。双方围绕中国高端旅行者的真实需求、Safari线路组合、亲子与蜜月产品、旺季资源协调、在地接待、可持续旅行和突发情况响应等议题交换了信息，建立了直接、友好的合作联系，并形成后续逐项对接产品与服务的意向。</p>

<div class="bg-[#f0f5ea] rounded-xl p-6 md:p-8 mb-8">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div class="flex items-start gap-3">
      <i class="ri-calendar-line text-[#1a4a1a] text-lg mt-1"></i>
      <div>
        <p class="text-xs text-[#5a7a4a] mb-0.5">活动时间</p>
        <p class="text-sm font-semibold text-[#1a2e10]">2026年5月</p>
      </div>
    </div>
    <div class="flex items-start gap-3">
      <i class="ri-map-pin-line text-[#1a4a1a] text-lg mt-1"></i>
      <div>
        <p class="text-xs text-[#5a7a4a] mb-0.5">活动地点</p>
        <p class="text-sm font-semibold text-[#1a2e10]">南非开普敦</p>
      </div>
    </div>
    <div class="flex items-start gap-3">
      <i class="ri-flag-line text-[#1a4a1a] text-lg mt-1"></i>
      <div>
        <p class="text-xs text-[#5a7a4a] mb-0.5">活动名称</p>
        <p class="text-sm font-semibold text-[#1a2e10]">We Are Africa 2026（WAA 2026）</p>
      </div>
    </div>
    <div class="flex items-start gap-3">
      <i class="ri-building-line text-[#1a4a1a] text-lg mt-1"></i>
      <div>
        <p class="text-xs text-[#5a7a4a] mb-0.5">交流品牌</p>
        <p class="text-sm font-semibold text-[#1a2e10]">数十家常合作的非洲野奢酒店及旅行品牌</p>
      </div>
    </div>
  </div>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <picture>
    <source media="(max-width: 768px)" srcset="${BRAND_MEETINGS_MOBILE}" />
    <img src="${BRAND_MEETINGS_DESKTOP}" alt="自由旷野旅行在We Are Africa 2026与数十家非洲野奢品牌代表交流合影" class="w-full h-auto object-cover" />
  </picture>
  <p class="text-sm text-stone-500 mt-2 text-center">自由旷野旅行在We Are Africa 2026与数十家非洲野奢品牌代表交流合影。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">为什么自由旷野旅行要参加 WAA？</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">高端非洲Safari不是简单地把酒店和车辆拼在一起。动物迁徙的位置会变化，奥卡万戈三角洲的水位有季节差异，不同营地对儿童入住、私人用车、步行游猎和包场体验也有不同规则。对中国旅行者来说，真正影响旅程质量的，往往是路线节奏、营地组合、向导匹配、航班衔接和突发情况处理。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">参加 WAA 的价值，是让自由旷野旅行能够直接与品牌和在地团队沟通，了解营地的新变化，并把中国客人的饮食、语言、亲子、安全、摄影和私密性需求带到供应端。与只依赖公开网页信息相比，面对面交流更有利于判断一间营地适合什么季节、什么客群，以及应该如何放进一条完整路线。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">现场重点交流了哪些品牌？</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">以下内容根据现场交流主题及各品牌公开产品特点整理，不是逐字会议记录，也不代表已经签署排他或独家协议。</p>

<div class="overflow-x-auto mb-8">
  <table class="w-full text-sm md:text-base border border-[#e8e0d4] rounded-xl overflow-hidden">
    <thead class="bg-[#e8f0e0]">
      <tr>
        <th class="px-4 py-3 text-left text-[#1a2e10] font-bold border-b border-[#e8e0d4]">品牌</th>
        <th class="px-4 py-3 text-left text-[#1a2e10] font-bold border-b border-[#e8e0d4]">主要目的地或资源方向</th>
        <th class="px-4 py-3 text-left text-[#1a2e10] font-bold border-b border-[#e8e0d4]">重点交流方向</th>
      </tr>
    </thead>
    <tbody class="divide-y divide-[#e8e0d4]">
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Singita</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亚及非洲多地</td><td class="px-4 py-3 text-[#5a7a4a]">格鲁米提与塞伦盖蒂高端住宿、私密体验、保护与社区项目</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Lemala Camps & Lodges</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亚、乌干达</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亚北部环线、迁徙季营地组合、亲子与私人用车</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Belmond</td><td class="px-4 py-3 text-[#5a7a4a]">博茨瓦纳、南非</td><td class="px-4 py-3 text-[#5a7a4a]">开普敦与博茨瓦纳联游、水陆空Safari组合</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">One Nature</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亚塞伦盖蒂</td><td class="px-4 py-3 text-[#5a7a4a]">塞伦盖蒂中部与北部组合、蜜月及纪念旅行</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Angama</td><td class="px-4 py-3 text-[#5a7a4a]">肯尼亚马赛马拉、安博塞利</td><td class="px-4 py-3 text-[#5a7a4a]">肯坦跨境、摄影、家庭与私人旅行</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Machaba Safaris</td><td class="px-4 py-3 text-[#5a7a4a]">博茨瓦纳、津巴布韦</td><td class="px-4 py-3 text-[#5a7a4a]">三角洲与国家公园组合、独木舟、步行和驱车游猎</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Jao Reserve</td><td class="px-4 py-3 text-[#5a7a4a]">博茨瓦纳奥卡万戈三角洲</td><td class="px-4 py-3 text-[#5a7a4a]">六家营地组合、水陆体验与不同水位季节</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">The Bushcamp Company</td><td class="px-4 py-3 text-[#5a7a4a]">赞比亚南卢安瓜</td><td class="px-4 py-3 text-[#5a7a4a]">步行Safari、营地串联、向导与安全标准</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Songa Africa</td><td class="px-4 py-3 text-[#5a7a4a]">非洲多目的地</td><td class="px-4 py-3 text-[#5a7a4a]">定制线路、跨区域地接协同和服务响应</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Karibu Camps & Lodges</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亚北部环线</td><td class="px-4 py-3 text-[#5a7a4a]">塞伦盖蒂、恩戈罗恩戈罗与塔兰吉雷营地衔接</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Acacia Collections</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亚北部环线</td><td class="px-4 py-3 text-[#5a7a4a]">迁徙营地、生态住宿与家庭房型组合</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Sisini Collection</td><td class="px-4 py-3 text-[#5a7a4a]">塞伦盖蒂、马赛马拉</td><td class="px-4 py-3 text-[#5a7a4a]">慢旅行、康养、在地餐饮与可持续体验</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Kantabile Afrika</td><td class="px-4 py-3 text-[#5a7a4a]">坦桑尼亚塞伦盖蒂</td><td class="px-4 py-3 text-[#5a7a4a]">Aurari与Cherero营地、迁徙季和小体量野奢体验</td></tr>
      <tr class="bg-[#faf8f5]"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Okavango Hidden Gems</td><td class="px-4 py-3 text-[#5a7a4a]">博茨瓦纳奥卡万戈三角洲</td><td class="px-4 py-3 text-[#5a7a4a]">低密度营地、水上活动和私密Safari</td></tr>
      <tr class="bg-white"><td class="px-4 py-3 font-semibold text-[#1a2e10]">Desert & Delta Safaris</td><td class="px-4 py-3 text-[#5a7a4a]">博茨瓦纳</td><td class="px-4 py-3 text-[#5a7a4a]">多营地环线、小飞机衔接、季节性水域体验</td></tr>
    </tbody>
  </table>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">1. Singita：顶奢体验不只在房间，也在保护理念与服务细节</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Singita在坦桑尼亚格鲁米提、塞伦盖蒂北部以及非洲其他保护区拥有营地、山庄和私人别墅。现场交流聚焦高私密度旅行、家庭及多人包栋、专业向导体验，以及如何让客人理解保护、社区与高端住宿之间的关系。双方希望在后续产品设计中，把“住得奢华”与“真正理解目的地”放在同一条体验线上。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA02}" alt="李志强与Singita代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Singita代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">2. Lemala Camps & Lodges：把坦桑尼亚北部环线做得更顺</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Lemala在塞伦盖蒂、恩戈罗恩戈罗、塔兰吉雷及乌干达拥有营地和度假产品。双方重点交流了坦桑尼亚北部环线的住宿组合、动物迁徙不同阶段的营地选择，以及亲子家庭对私人车辆、连续住宿和餐饮沟通的需求。后续对接方向，是根据出行月份和家庭结构匹配合适的Lemala营地，而不是只按品牌知名度选酒店。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA01}" alt="李志强与Lemala Camps & Lodges代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Lemala Camps & Lodges代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">3. Belmond：从开普敦城市体验延伸到博茨瓦纳荒野</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Belmond在开普敦及博茨瓦纳拥有酒店和Safari产品。交流重点是如何把城市停留与奥卡万戈三角洲、萨武蒂等荒野体验自然衔接，并结合驱车、船只及观景飞行等方式，减少单一活动带来的重复感。蜜月、纪念旅行和希望兼顾舒适度的家庭，是双方重点讨论的客群。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA03}" alt="李志强与Belmond代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Belmond代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">4. One Nature：用塞伦盖蒂中部与北部形成季节互补</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">One Nature的公开产品包括塞伦盖蒂中部Nyaruswiga和北部Mara River。双方讨论了如何依据迁徙位置安排中部与北部住宿、如何控制连续换营地的疲劳，以及蜜月、生日和家庭纪念旅行对私密餐饮与个性化布置的需求。重点不是追求“每天换一家”，而是让客人在合适区域住够时间。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA04}" alt="李志强与One Nature代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与One Nature代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">5. Angama：连接马赛马拉、安博塞利与东非跨境路线</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Angama的核心产品位于肯尼亚马赛马拉和安博塞利。双方交流了肯尼亚与坦桑尼亚跨境线路的节奏、空中与陆路衔接、摄影客人的出发时间，以及多代家庭对空间和私人活动的需求。对于同时想看马赛马拉草原与乞力马扎罗山景观的客人，后续可以根据季节做更清晰的路线取舍。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA05}" alt="李志强与Angama代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Angama代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">6. Machaba Safaris：根据水位和季节组合博茨瓦纳与津巴布韦</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Machaba Safaris在博茨瓦纳和津巴布韦运营多家生态野奢营地。现场讨论围绕奥卡万戈三角洲、乔贝、万基与马纳潭等区域的组合逻辑，以及独木舟、步行Safari和驱车游猎如何互补。双方特别关注水位变化对活动安排的影响，希望在行前就把“能看到什么、能参加什么”解释清楚。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA06}" alt="李志强与Machaba Safaris代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Machaba Safaris代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">7. Jao Reserve：用不同营地看见奥卡万戈的水与陆地</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Jao Reserve位于博茨瓦纳奥卡万戈三角洲，旗下营地呈现不同的水域和陆地生态。双方交流了六家营地之间的差异、住几晚更合理，以及独木舟、船游、步行和驱车体验的季节适配。后续路线设计将更重视营地之间的生态差异，避免只换酒店、不换体验。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA07}" alt="李志强与Jao Reserve代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Jao Reserve代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">8. The Bushcamp Company：把南卢安瓜步行Safari讲清楚</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">The Bushcamp Company深耕赞比亚南卢安瓜，以步行Safari和小型营地串联见长。双方重点交流了步行强度、向导匹配、安全说明、行李转运和营地之间的衔接。对于希望深入荒野而非只在车上观兽的客人，赞比亚可以成为与东非完全不同的第二次Safari选择。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA08}" alt="李志强与The Bushcamp Company代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与The Bushcamp Company代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">9. Songa Africa：强化跨目的地行程的在地协同</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Songa Africa专注非洲定制旅行与营地资源。交流内容集中在跨区域线路的落地执行，包括机场接送、内陆航班、供应商沟通、饮食偏好、临时调整和紧急响应。双方希望通过更直接的信息链路，减少多国行程中因层层转达产生的误差。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA09}" alt="李志强与Songa Africa代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Songa Africa代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">10. Karibu Camps & Lodges：围绕坦桑尼亚北部经典公园做组合</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Karibu Camps & Lodges的产品覆盖塞伦盖蒂、恩戈罗恩戈罗和塔兰吉雷。双方讨论了不同营地的地理位置、连续住宿天数、家庭房型以及摄影客人的早出晚归安排。后续将根据季节和客人关注的动物场景组合营地，不用同一套模板覆盖全年。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA10}" alt="李志强与Karibu Camps & Lodges代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Karibu Camps & Lodges代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">11. Acacia Collections：兼顾迁徙位置、生态设计与家庭需求</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Acacia Collections在塞伦盖蒂、塔兰吉雷和恩戈罗恩戈罗布局营地及生态住宿。现场交流包括迁徙营地的开放位置、家庭与蜜月房型、跨营地交通以及可持续运营实践。双方希望把这些信息转化成更透明的行前说明，让客人知道营地位置为什么会影响每天的游猎时间。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA11}" alt="李志强与Acacia Collections代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Acacia Collections代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">12. Sisini Collection：把康养、餐饮与慢节奏放进Safari</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Sisini Collection强调与自然连接、康养和在地饮食体验。双方讨论了塞伦盖蒂与马赛马拉产品如何服务希望放慢节奏的客人，以及农场到餐桌、静心休息和轻量自然活动如何与传统驱车游猎结合。这样的产品更适合不希望每天从清晨赶到夜晚的旅行者。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA12}" alt="李志强与Sisini Collection代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Sisini Collection代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">13. Kantabile Afrika：小体量营地与塞伦盖蒂迁徙季体验</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Kantabile Afrika由业主设计并运营Aurari Camp和Cherero Camp，强调小体量、生态意识与在地审美。双方重点交流了北部塞伦盖蒂迁徙季、营地开放时间、私人车辆和纪念旅行安排，以及如何向中国客人解释“小型营地”在私密性和服务温度上的优势。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA13}" alt="李志强与Kantabile Afrika代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Kantabile Afrika代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">14. Okavango Hidden Gems：低密度方式体验三角洲</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Okavango Hidden Gems位于博茨瓦纳奥卡万戈三角洲区域。交流重点是永久水道附近的水上体验、不同月份的景观变化、小体量营地的私密性，以及适合情侣、家庭和小团体的活动节奏。双方希望在产品中明确季节差异，避免把三角洲描述成全年完全相同的景观。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA14}" alt="李志强与Okavango Hidden Gems代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Okavango Hidden Gems代表在WAA 2026现场合影。</p>
</div>

<h3 class="text-xl md:text-2xl font-bold text-[#0d3320] mt-10 mb-4">15. Desert & Delta Safaris：把博茨瓦纳多营地环线衔接得更稳定</h3>

<p class="text-base md:text-lg leading-[1.8] mb-6">Desert & Delta Safaris长期运营博茨瓦纳多家Safari营地，并强调本地团队管理。双方讨论了不同生态区域之间的小飞机衔接、旱季与水季差异、连续入住和多营地组合，以及在突发航班变化时的信息响应。目标是让博茨瓦纳路线既有丰富变化，也保持清晰、稳定的执行节奏。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA15}" alt="李志强与Desert & Delta Safaris代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Desert & Delta Safaris代表在WAA 2026现场合影。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">这次交流会怎样影响自由旷野的Safari产品？</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">WAA之后，自由旷野旅行将把这些一线信息逐步用于非洲Safari方案设计：根据季节选择营地，而不是只看品牌；根据客人年龄、体能和兴趣匹配活动；在报价前明确儿童政策、用车方式、行李限制和接驳条件；在多国或多营地路线中缩短信息链路；把保护、社区和在地文化纳入旅行体验，而不是只追求酒店等级。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">对客人而言，这些行业交流最直接的价值，不是多出一串品牌名称，而是获得更适合自己的路线、更清楚的选择理由，以及出现变化时更高效的沟通。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">WAA 2026现场交流影像</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">以下照片均为李志强在WAA展会现场与相关品牌代表的真实交流合影。照片记录的是面对面沟通和友好联系，不单独作为签约、独家代理或官方授权证明。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA02}" alt="李志强与Singita代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Singita代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA01}" alt="李志强与Lemala Camps & Lodges代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Lemala Camps & Lodges代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA03}" alt="李志强与Belmond代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Belmond代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA04}" alt="李志强与One Nature代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与One Nature代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA05}" alt="李志强与Angama代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Angama代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA06}" alt="李志强与Machaba Safaris代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Machaba Safaris代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA07}" alt="李志强与Jao Reserve代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Jao Reserve代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA08}" alt="李志强与The Bushcamp Company代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与The Bushcamp Company代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA09}" alt="李志强与Songa Africa代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Songa Africa代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA10}" alt="李志强与Karibu Camps & Lodges代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Karibu Camps & Lodges代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA11}" alt="李志强与Acacia Collections代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Acacia Collections代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA12}" alt="李志强与Sisini Collection代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Sisini Collection代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA13}" alt="李志强与Kantabile Afrika代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Kantabile Afrika代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA14}" alt="李志强与Okavango Hidden Gems代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Okavango Hidden Gems代表在WAA 2026现场合影。</p>
</div>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${WAA15}" alt="李志强与Desert & Delta Safaris代表在WAA 2026现场合影" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">李志强与Desert & Delta Safaris代表在WAA 2026现场合影。</p>
</div>

<div class="bg-[#e8f0e0] rounded-xl p-6 md:p-8 my-10">
  <p class="text-[#1a4a1a] font-bold text-lg mb-2">关于自由旷野旅行</p>
  <p class="text-stone-700 text-sm md:text-base leading-relaxed">自由旷野旅行（Free Wilderness Travel）由成都自由旷野国际旅行社有限公司运营，专注非洲Safari、极地探索及自然类高端定制旅行。团队通过目的地考察、行业展会交流和在地资源沟通，持续更新行程设计与服务信息，为旅行者提供一对一方案建议。</p>
  <p class="text-stone-700 text-sm md:text-base leading-relaxed mt-2">如果你正在规划坦桑尼亚动物大迁徙、肯尼亚马赛马拉、博茨瓦纳奥卡万戈三角洲、赞比亚步行Safari或多国联游，可以向自由旷野旅行说明出行月份、人数、预算、儿童年龄和体验偏好，由旅行顾问协助匹配路线与营地。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6 text-sm text-stone-500">资料说明：展会背景参考We Are Africa官方公开信息；品牌目的地和产品信息参考各品牌官网。文中“交流重点”为基于现场会谈主题及品牌公开资料进行的编辑整理，不是逐字会议纪要。具体产品、价格、房态、合作关系和服务内容以相关方后续书面确认及实际预订为准。</p>
`;

/* ─────────────────────────────────────────────
   实地考察文章：2026 非洲多国高端 Safari 野奢资源调研
   路由：/wiki/brand/founder-africa-luxury-scouting-2026
   ───────────────────────────────────────────── */
const founderScoutContent = `
<p class="text-base md:text-lg leading-[1.8] mb-6">2026年上半年，自由旷野旅行创始人李志强受 Belmond、Wilderness、African Bush Camps、Sirikoi、Cottar's Safaris 多家非洲野奢旅行品牌邀请，先后赴肯尼亚、博茨瓦纳、卢旺达，对当地多处高端野生动物保护区及野奢营地开展实地调研。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">非洲 Safari 旅行的实际体验，受保护区区位、季节气候、营地硬件资源、车辆向导服务、区域交通衔接多重现实条件制约。对于从事非洲出境旅行的从业者而言，赴目的地实地走访核验，是梳理资源、认知产品差异的重要途径。本次调研覆盖东非、南部非洲不同类型 Safari 目的地，涉及草原、内陆三角洲湿地、山地森林等差异化生态。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">调研人</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">调研人：李志强，自由旷野旅行创始人，深耕非洲高端 Safari 旅行领域多年，长期走访非洲多国野奢营地与自然保护区，专注非洲 Safari 目的地资源调研。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT01}" alt="自由旷野旅行创始人李志强" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">自由旷野旅行创始人李志强。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">1月｜肯尼亚：私属保护区 Safari 资源调研</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2026年1月，调研在肯尼亚开展，重点走访莱瓦野生动物保护区内 Sirikoi 营地，以及马赛马拉私人保护区的 Cottar's 1920s Camp。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">莱瓦野生动物保护区面积超60平方公里，区内仅布局5处营地，整体游客接待密度较低，同时也是肯尼亚犀牛保护的重要区域，承担黑、白犀牛保护相关工作。调研过程中，重点梳理了莱瓦保护区游猎动线、保护区运营模式，以及当地野生动物保护落地实践。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT02}" alt="肯尼亚莱瓦野生动物保护区内的Sirikoi营地" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">肯尼亚莱瓦野生动物保护区内的 Sirikoi 营地。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">Cottar's 1920s Camp 坐落于马赛马拉私人保护区，地处肯尼亚与坦桑尼亚交界地带，营地选址海拔2100余米，视野可俯瞰塞伦盖蒂北部区域。该营地于2025年完成升级，帐篷采用全纱窗通风设计，配套露台与私人泡池，可提供私人向导、四驱游猎车辆、徒步 Safari 以及在地文化探访等体验项目。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT03}" alt="马赛马拉私人保护区的Cottar's 1920s Camp" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">马赛马拉私人保护区的 Cottar's 1920s Camp。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">本次实地走访，收集了马赛马拉及周边私人保护区的一线实地信息，为理解不同保护区组合线路的现实差异提供参考。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">5月中旬｜博茨瓦纳：三角洲与陆地生态营地调研</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">2026年5月，调研团队在博茨瓦纳开展十余天实地走访，先后体验 Belmond、African Bush Camps 旗下多家代表性营地，对比奥卡万戈三角洲湿地、乔贝国家公园陆地两大截然不同的 Safari 生态体系。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT04}" alt="博茨瓦纳奥卡万戈三角洲与乔贝国家公园的Safari生态" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">博茨瓦纳奥卡万戈三角洲湿地与乔贝国家公园陆地两大 Safari 生态体系。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">Belmond 在博茨瓦纳运营两处 Safari 营地，分别为 Eagle Island Lodge 与 Savute Elephant Lodge。Eagle Island Lodge 坐落于世界自然遗产奥卡万戈三角洲的 Xaxaba 岛屿，共有12间客房，客房配备私人泳池。依托三角洲水系条件，可开展陆地游猎、Mokoro 独木舟、水上观光、直升机游览等多种体验。奥卡万戈三角洲旅行体验受水位季节性波动影响显著，水位变化直接决定可开展的游玩项目。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT05}" alt="Belmond Eagle Island Lodge坐落于奥卡万戈三角洲" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">Belmond Eagle Island Lodge 坐落于奥卡万戈三角洲 Xaxaba 岛屿。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">Savute Elephant Lodge 地处乔贝国家公园萨武特河道沿线，设置12间帐篷客房，营地毗邻永久动物水源点，以陆地野生动物游猎为核心体验，搭配自然科普与本土人文活动。该营地与奥卡万戈三角洲水域营地形成生态场景的鲜明对比。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT06}" alt="乔贝国家公园萨武特河道沿线的Savute Elephant Lodge" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">乔贝国家公园萨武特河道沿线的 Savute Elephant Lodge。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">同期，调研还走访 African Bush Camps 旗下 Khwai Leadwood 与 Atzaró Okavango Camp 两处营地。Khwai Leadwood 地处 Khwai 区域，周边汇集河道、林地、开阔草原多重地貌，调研重点记录该片区动物观测条件、游客车辆密度、可开展活动类型，以及与莫雷米保护区周边区域的通行衔接情况。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT07}" alt="African Bush Camps旗下Khwai Leadwood营地" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">African Bush Camps 旗下 Khwai Leadwood 营地。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">Atzaró Okavango Camp 是 African Bush Camps 近年推出的高端营地项目，位于奥卡万戈三角洲腹地。营地保留荒野生态属性的同时，侧重住宿空间设计、餐饮康养类配套，区别于传统以高强度动物观测为主的 Safari 营地，适配希望兼顾游猎体验与休闲度假节奏的客群。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT08}" alt="African Bush Camps旗下Atzaró Okavango Camp高端营地" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">African Bush Camps 旗下 Atzaró Okavango Camp 高端营地。</p>
</div>

<p class="text-base md:text-lg leading-[1.8] mb-6">博茨瓦纳不同营地分属不同生态片区，线路规划需要结合营地所处地貌、季节水位条件，同时考量内陆小飞机接驳、向导车队配置、跨区域路线串联等现实问题，也是本次调研重点关注的内容。</p>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">5月底｜卢旺达：山地大猩猩生态旅行调研</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">结束博茨瓦纳行程后，2026年5月底，调研团队受 Wilderness 邀请，前往卢旺达，实地考察 Wilderness Bisate 营地及火山国家公园相关旅行资源。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">Bisate 营地毗邻火山国家公园，该区域旅行核心为山地大猩猩追踪，与东非草原、博茨瓦纳三角洲的 Safari 模式存在明显区别。大猩猩追踪出行受国家公园管理制度、徒步难度、许可配额等多重条件约束。本次调研梳理火山国家公园周边交通、大猩猩追踪活动组织流程，以及卢旺达高端自然旅行的服务流程，同时考察卢旺达与东非 Safari 线路之间的联动可行性。</p>

<div class="my-8 rounded-xl overflow-hidden">
  <img src="${SCOUT09}" alt="卢旺达火山国家公园毗邻的Wilderness Bisate营地" class="w-full h-auto object-cover" />
  <p class="text-sm text-stone-500 mt-2 text-center">卢旺达火山国家公园毗邻的 Wilderness Bisate 营地。</p>
</div>

<h2 class="text-2xl md:text-3xl font-bold text-[#0d3320] mt-12 mb-6">行业观察结语</h2>

<p class="text-base md:text-lg leading-[1.8] mb-6">非洲高端 Safari 旅行，并不简单等同于高端住宿的叠加，目的地生态条件、季节周期、营地区位、在地服务体系，共同决定旅行产品的实际落地效果。</p>

<p class="text-base md:text-lg leading-[1.8] mb-6">随着国内高端出境游需求增长，游客对非洲 Safari 的需求逐步从标准化观光，转向沉浸式、个性化的深度体验。非洲不同国家之间地貌、物种、保护政策差异巨大，草原、内陆湿地、山地森林形成各自独立的旅行体系。行业从业者需要持续跟进目的地营地迭代、生态季节变化，厘清不同区域资源的适配边界，才能匹配国内游客多元化出行诉求，推动非洲野奢旅行向更精细化的方向发展。</p>

<div class="bg-[#e8f0e0] rounded-xl p-6 md:p-8 my-10">
  <p class="text-[#1a4a1a] font-bold text-lg mb-2">关于自由旷野旅行</p>
  <p class="text-stone-700 text-sm md:text-base leading-relaxed">自由旷野旅行（Free Wilderness Travel）由成都自由旷野国际旅行社有限公司运营，专注非洲 Safari、南北极及自然类高端定制旅行。团队通过目的地实地考察、营地入住核验与在地资源沟通，持续更新线路设计与服务信息，为旅行者提供一对一方案建议。</p>
  <p class="text-stone-700 text-sm md:text-base leading-relaxed mt-2">官方网站：<a href="https://freewds.com/" class="text-[#1a4a1a] hover:underline" target="_blank" rel="noopener noreferrer">https://freewds.com/</a></p>
</div>
`;

const founderScoutFaq = [
  {
    question: '这次实地调研覆盖了哪些国家和营地？',
    answer: "2026年上半年，调研覆盖肯尼亚、博茨瓦纳、卢旺达三个国家，实地走访了莱瓦 Sirikoi 营地、Cottar's 1920s Camp、Belmond 旗下 Eagle Island Lodge 与 Savute Elephant Lodge、African Bush Camps 旗下 Khwai Leadwood 与 Atzaró Okavango Camp，以及卢旺达 Wilderness Bisate 营地等。",
  },
  {
    question: '实地调研对旅行者有什么实际帮助？',
    answer: '实地走访让自由旷野旅行能更准确判断营地所在区域、季节水位、活动方式、交通衔接与服务细节，从而为不同客人匹配更合适的 Safari 路线与营地组合，而不是只看品牌知名度或公开图片。',
  },
  {
    question: '这些实地走访是否代表已签署独家合作协议？',
    answer: '不代表。实地考察与入住体验证明团队进行过真实抵达与现场核验，但不单独等同于签约、独家代理或官方授权。具体合作产品、价格、房态以相关方后续书面确认及实际预订为准。',
  },
];

export const wikiBrandArticles: WikiBrandArticle[] = [
  {
    slug: 'founder-field-notes',
    title: '从东非草原到卢旺达山地森林：李志强与自由旷野团队的实地足迹',
    metaTitle: '从东非草原到卢旺达山地森林：李志强与自由旷野团队的实地足迹',
    metaDescription:
      '李志强自2013年进入高端定制旅行行业，持续前往坦桑尼亚、博茨瓦纳、卢旺达、南极和格陵兰等目的地进行实地体验。自由旷野旅行于2022年成立，并将长期目的地经验用于非洲Safari、南北极及自然旅行的线路策划与服务。',
    metaKeywords: '自由旷野旅行创始人,李志强,非洲Safari实地考察,坦桑尼亚Safari,博茨瓦纳旅行,卢旺达大猩猩旅行,非洲旅行团队',
    category: '品牌百科',
    subcategory: '人物故事',
    excerpt:
      '李志强自2013年进入高端定制旅行行业，持续前往坦桑尼亚、博茨瓦纳、卢旺达、南极和格陵兰等目的地进行实地体验。自由旷野旅行于2022年成立，并将长期目的地经验用于非洲Safari、南北极及自然旅行的线路策划与服务。',
    content: founderFieldNotesContent,
    image: IMG_01,
    readTime: '',
    tags: ['品牌故事', '创始人', '实地考察', '非洲Safari', '南极', '卢旺达'],
    date: '',
    author: '',
    authorRole: '',
    faq: [],
  },
  {
    slug: 'brand-cooperation-exchange',
    title: '自由旷野旅行参加 We Are Africa 2026：与数十家非洲野奢品牌建立友好合作联系',
    metaTitle: '自由旷野旅行参加 We Are Africa 2026：与数十家非洲野奢品牌建立友好合作联系',
    metaDescription: '2026年5月，自由旷野旅行参加南非开普敦We Are Africa 2026，与Lemala、Singita、Belmond、One Nature、Angama等数十家非洲野奢品牌建立友好合作联系。',
    metaKeywords: '自由旷野旅行,We Are Africa 2026,WAA,非洲野奢品牌,品牌合作,非洲Safari',
    category: '品牌百科',
    subcategory: '品牌合作',
    excerpt: '2026年5月，自由旷野旅行前往南非开普敦参加We Are Africa 2026，与数十家非洲野奢酒店及旅行品牌代表进行面对面交流，围绕Safari线路、亲子蜜月产品、旺季资源协调等议题交换信息，建立直接合作联系。',
    content: brandMeetingsContent,
    image: BRAND_MEETINGS_DESKTOP,
    readTime: '12分钟',
    tags: ['品牌合作', 'We Are Africa', '野奢营地', '非洲Safari', '实地考察'],
    date: '2026-09-04',
    author: '自由旷野旅行',
    authorRole: '品牌团队',
    faq: brandMeetingsFaq,
  },
  {
    slug: 'founder-africa-luxury-scouting-2026',
    title: '2026年自由旷野旅行创始人李志强赴非洲多国开展高端Safari野奢资源实地调研',
    metaTitle: '2026年自由旷野旅行创始人李志强赴非洲多国开展高端Safari野奢资源实地调研',
    metaDescription: "2026年上半年，自由旷野旅行创始人李志强受邀赴肯尼亚、博茨瓦纳、卢旺达，实地调研 Belmond、Wilderness、African Bush Camps、Sirikoi、Cottar's Safaris 等高端野奢营地的保护区区位、季节气候、营地硬件与交通衔接，为高端 Safari 线路设计提供一手判断依据。",
    metaKeywords: '自由旷野旅行,李志强,非洲Safari实地调研,肯尼亚Sirikoi,博茨瓦纳Belmond,卢旺达Bisate,高端野奢营地,山地大猩猩追踪',
    category: '品牌百科',
    subcategory: '实地考察',
    excerpt: "2026年上半年，自由旷野旅行创始人李志强受邀赴肯尼亚、博茨瓦纳、卢旺达，实地调研 Sirikoi、Cottar's、Belmond、Wilderness 等高端野奢营地，为高端 Safari 线路设计积累一手判断。",
    content: founderScoutContent,
    image: SCOUT01,
    readTime: '8分钟',
    tags: ['实地考察', '非洲Safari', '野奢营地', '肯尼亚', '博茨瓦纳', '卢旺达'],
    date: '2026-09-04',
    author: '李志强',
    authorRole: '自由旷野旅行创始人',
    faq: founderScoutFaq,
  },
];